import React from 'react';
import {
  ADD_THIS_TO_NOTES,
  ADD_THIS_TO_THE_NOTE,
  ADD_TO_NOTE_FAILED,
  ADD_TO_NOTE_NEEDS_REPLY,
  ADDED_TO_NOTES,
  ADDED_TO_THE_NOTE,
  ATTACHED_DOC,
  ATTACHED_NOTE,
  CLEAR_ATTACHMENT,
} from '../../utils/writerCopy';

/** Chip above the message box. Closing it drops the attachment only. */
export default function ChatAttachmentBar({
  attachment,
  onClear,
  onAdd,
  status = 'idle',
}) {
  if (!attachment?.label) return null;
  const note = attachment.kind === 'note';
  const label = note ? ATTACHED_NOTE(attachment.label) : ATTACHED_DOC(attachment.label);
  const addLabel = note ? ADD_THIS_TO_THE_NOTE : ADD_THIS_TO_NOTES;
  let noteText = '';
  if (status === 'added') noteText = note ? ADDED_TO_THE_NOTE : ADDED_TO_NOTES;
  if (status === 'empty') noteText = ADD_TO_NOTE_NEEDS_REPLY;
  if (status === 'error') noteText = ADD_TO_NOTE_FAILED;

  return (
    <div className="chat-attach" data-testid="chat-attachment">
      <p className="chat-attach__chip">
        <span>{label}</span>
        <button type="button" aria-label={CLEAR_ATTACHMENT} onClick={onClear}>
          ✕
        </button>
      </p>
      <button type="button" className="chat-attach__add" onClick={onAdd} disabled={status === 'adding'}>
        {addLabel}
      </button>
      {noteText ? <p className="chat-attach__status" role="status">{noteText}</p> : null}
    </div>
  );
}
